export const REPORT_PREVIEW_WIDTH = 1120;
const REPORT_PREVIEW_WATERMARK = "NOT FINAL COPY";
const REPORT_PREVIEW_WATERMARK_SVG =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='1200' viewBox='0 0 900 1200'%3E%3Cg transform='translate(450 600) rotate(-32)'%3E%3Crect x='-315' y='-78' width='630' height='156' rx='10' fill='none' stroke='rgba(0,0,0,0.14)' stroke-width='6'/%3E%3Ctext x='0' y='22' text-anchor='middle' fill='rgba(0,0,0,0.16)' font-family='Arial, Helvetica, sans-serif' font-size='72' font-weight='800' letter-spacing='8'%3ENOT FINAL COPY%3C/text%3E%3C/g%3E%3C/svg%3E";

function escapeHtml(value = "") {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function ensurePrintableReportHtml(html = "") {
  if (!html || html.includes('id="report-preview-print-overrides"')) {
    return html;
  }

  const printOverrides = `
<style id="report-preview-print-overrides">
  html, body {
    height: auto !important;
    min-height: 0 !important;
    overflow: visible !important;
  }
  body {
    position: relative !important;
  }
  #report-preview-watermark-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    pointer-events: none;
    z-index: 2147483646;
    display: none;
  }
  .report-preview-watermark-mark {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-32deg);
    border: 6px solid rgba(0, 0, 0, 0.14);
    color: rgba(0, 0, 0, 0.16);
    font-family: Arial, Helvetica, sans-serif;
    font-size: 72px;
    font-weight: 800;
    letter-spacing: 8px;
    line-height: 1;
    padding: 24px 36px;
    text-transform: uppercase;
    white-space: nowrap;
  }
  @media print {
    @page {
      margin: 8mm;
      size: auto;
    }
    html, body {
      height: auto !important;
      min-height: 0 !important;
      width: auto !important;
      min-width: 0 !important;
      overflow: visible !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    #report-preview-watermark-layer {
      display: block !important;
    }
  }
</style>`;

  const watermarkScript = `
<script id="report-preview-watermark-script">
  (function attachPageWatermarks() {
    var LAYER_ID = "report-preview-watermark-layer";
    var PAGE_HEIGHT_MM = 297 - 16;
    var PX_PER_MM = 96 / 25.4;
    var pageHeightPx = Math.max(900, Math.round(PAGE_HEIGHT_MM * PX_PER_MM));

    function renderWatermarkLayer() {
      var body = document.body;
      if (!body) return;

      var prev = document.getElementById(LAYER_ID);
      if (prev) prev.remove();

      var docEl = document.documentElement;
      var totalHeight = Math.max(
        body.scrollHeight || 0,
        body.offsetHeight || 0,
        docEl ? docEl.scrollHeight || 0 : 0,
        docEl ? docEl.offsetHeight || 0 : 0
      );

      var count = Math.max(1, Math.ceil(totalHeight / pageHeightPx));
      var layer = document.createElement("div");
      layer.id = LAYER_ID;
      layer.style.height = totalHeight + "px";

      for (var i = 0; i < count; i += 1) {
        var mark = document.createElement("div");
        mark.className = "report-preview-watermark-mark";
        mark.textContent = "${REPORT_PREVIEW_WATERMARK}";
        mark.style.top = Math.round(i * pageHeightPx + pageHeightPx / 2) + "px";
        layer.appendChild(mark);
      }

      body.appendChild(layer);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", renderWatermarkLayer, { once: true });
    } else {
      renderWatermarkLayer();
    }

    window.addEventListener("beforeprint", renderWatermarkLayer);
  })();
</script>`;

  if (/<head[^>]*>/i.test(html)) {
    return html.replace(/<head[^>]*>/i, (match) => `${match}${printOverrides}${watermarkScript}`);
  }

  return `${printOverrides}${watermarkScript}${html}`;
}

function renderPerPageWatermarkLayer(doc) {
  if (!doc?.body) return;

  const layerId = "report-preview-watermark-layer";
  const pageHeightMm = 297 - 16;
  const pxPerMm = 96 / 25.4;
  const pageHeightPx = Math.max(900, Math.round(pageHeightMm * pxPerMm));

  const previous = doc.getElementById(layerId);
  if (previous) previous.remove();

  const body = doc.body;
  const docEl = doc.documentElement;
  const totalHeight = Math.max(
    body.scrollHeight || 0,
    body.offsetHeight || 0,
    docEl ? docEl.scrollHeight || 0 : 0,
    docEl ? docEl.offsetHeight || 0 : 0
  );
  const count = Math.max(1, Math.ceil(totalHeight / pageHeightPx));

  const layer = doc.createElement("div");
  layer.id = layerId;
  layer.style.position = "absolute";
  layer.style.top = "0";
  layer.style.left = "0";
  layer.style.width = "100%";
  layer.style.height = `${totalHeight}px`;
  layer.style.pointerEvents = "none";
  layer.style.zIndex = "2147483646";

  for (let i = 0; i < count; i += 1) {
    const mark = doc.createElement("div");
    mark.className = "report-preview-watermark-mark";
    mark.textContent = REPORT_PREVIEW_WATERMARK;
    mark.style.position = "absolute";
    mark.style.left = "50%";
    mark.style.top = `${Math.round(i * pageHeightPx + pageHeightPx / 2)}px`;
    mark.style.transform = "translate(-50%, -50%) rotate(-32deg)";
    mark.style.border = "6px solid rgba(0, 0, 0, 0.14)";
    mark.style.color = "rgba(0, 0, 0, 0.16)";
    mark.style.fontFamily = "Arial, Helvetica, sans-serif";
    mark.style.fontSize = "72px";
    mark.style.fontWeight = "800";
    mark.style.letterSpacing = "8px";
    mark.style.lineHeight = "1";
    mark.style.padding = "24px 36px";
    mark.style.textTransform = "uppercase";
    mark.style.whiteSpace = "nowrap";
    layer.appendChild(mark);
  }

  body.appendChild(layer);
}

function printWindowWhenReady(printWindow, title = "Report Preview") {
  const doc = printWindow?.document;
  if (!doc) return;

  let didPrint = false;
  const doPrint = () => {
    if (didPrint) return;
    didPrint = true;
    renderPerPageWatermarkLayer(doc);
    printWindow.document.title = title;
    printWindow.focus();
    printWindow.print();
  };

  const printAfterFonts = () => {
    if (doc.fonts?.ready && typeof doc.fonts.ready.then === "function") {
      doc.fonts.ready.finally(() => {
        printWindow.setTimeout(doPrint, 80);
      });
      return;
    }
    printWindow.setTimeout(doPrint, 80);
  };

  const pendingImages = Array.from(doc.images || []).filter((img) => !img.complete);
  if (pendingImages.length === 0) {
    printAfterFonts();
    return;
  }

  let remaining = pendingImages.length;
  const onImageSettled = () => {
    remaining -= 1;
    if (remaining <= 0) {
      printAfterFonts();
    }
  };

  pendingImages.forEach((img) => {
    img.addEventListener("load", onImageSettled, { once: true });
    img.addEventListener("error", onImageSettled, { once: true });
  });

  // Fallback if one of the load/error events does not fire.
  printWindow.setTimeout(printAfterFonts, 3200);
}

export function printReportPreviewHtml(html = "", title = "Report Preview") {
  if (!html || typeof window === "undefined") {
    return false;
  }

  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    return false;
  }

  const normalizedHtml = ensurePrintableReportHtml(html);
  printWindow.document.open();
  printWindow.document.write(normalizedHtml);
  printWindow.document.close();
  printWindow.focus();

  const handleLoad = () => {
    printWindowWhenReady(printWindow, title);
  };

  if (printWindow.document.readyState === "complete") {
    handleLoad();
  } else {
    printWindow.addEventListener("load", handleLoad, { once: true });
    printWindow.setTimeout(handleLoad, 1400);
  }

  return true;
}

export function printReportPreviewHtmlList(htmlList = [], title = "Report Preview") {
  const reports = htmlList.filter(Boolean).map((reportHtml) => ensurePrintableReportHtml(reportHtml));
  if (reports.length === 0 || typeof window === "undefined") {
    return false;
  }
  if (reports.length === 1) {
    return printReportPreviewHtml(reports[0], title);
  }

  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    return false;
  }

  const extractHead = (reportHtml = "") => {
    const headMatch = reportHtml.match(/<head[^>]*>([\s\S]*?)<\/head>/i);
    return headMatch ? headMatch[1] : "";
  };

  const extractBody = (reportHtml = "") => {
    const bodyMatch = reportHtml.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    return bodyMatch ? bodyMatch[1] : reportHtml;
  };

  const styleBlockPattern = /<style[\s\S]*?<\/style>/gi;
  const stylesheetLinkPattern = /<link[^>]*rel=["'][^"']*stylesheet[^"']*["'][^>]*>/gi;
  const scriptPattern = /<script[\s\S]*?<\/script>/gi;

  const collectedHeadAssets = reports
    .map((reportHtml) => extractHead(reportHtml))
    .map((headHtml) => {
      const styles = headHtml.match(styleBlockPattern) || [];
      const links = headHtml.match(stylesheetLinkPattern) || [];
      return `${links.join("\n")}\n${styles.join("\n")}`.trim();
    })
    .filter(Boolean)
    .join("\n");

  const mergedBody = reports
    .map((reportHtml, index) => {
      const bodyHtml = extractBody(reportHtml)
        .replace(scriptPattern, "")
        .trim();
      const isLast = index === reports.length - 1;
      return `<section class="report-preview-merged-report${isLast ? "" : " report-preview-merged-report--page-break"}">${bodyHtml}</section>`;
    })
    .join("\n");

  const printableShell = `<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8">
    <title>${escapeHtml(title)}</title>
    <style id="report-preview-batch-print-style">
      html,
      body {
        margin: 0;
        padding: 0;
        background: #ffffff;
      }
      .report-preview-merged-report {
        width: auto;
        min-width: 0;
      }
      @media print {
        @page {
          margin: 8mm;
          size: auto;
        }
        body {
          position: relative !important;
          background-image: none !important;
        }
        body::before {
          content: none !important;
          display: none !important;
        }
        #report-preview-watermark-layer {
          display: block !important;
        }
        .report-preview-merged-report {
          break-inside: auto;
          page-break-inside: auto;
        }
        .report-preview-merged-report--page-break {
          break-after: page;
          page-break-after: always;
        }
      }
    </style>
    ${collectedHeadAssets}
  </head>
  <body>${mergedBody}</body>
</html>`;

  printWindow.document.open();
  printWindow.document.write(printableShell);
  printWindow.document.close();

  const handleLoad = () => {
    printWindowWhenReady(printWindow, title);
  };

  if (printWindow.document.readyState === "complete") {
    handleLoad();
  } else {
    printWindow.addEventListener("load", handleLoad, { once: true });
    printWindow.setTimeout(handleLoad, 1800);
  }

  return true;
}

export default function ensureLightReportPreviewHtml(html = "") {
  if (!html || html.includes("id=\"light-report-preview-style\"")) {
    return html;
  }

  const viewportMeta = `<meta name="viewport" content="width=${REPORT_PREVIEW_WIDTH}, initial-scale=1.0">`;
  const hasViewportMeta = /<meta[^>]+name=["']viewport["'][^>]*>/i.test(html);

  const lightStyle = `
${hasViewportMeta ? "" : viewportMeta}
<style id="light-report-preview-style">
  :root { color-scheme: light !important; }
  html, body {
    background: #ffffff !important;
    color: #000000 !important;
    width: ${REPORT_PREVIEW_WIDTH}px !important;
    min-width: ${REPORT_PREVIEW_WIDTH}px !important;
    max-width: none !important;
    overflow-x: auto !important;
  }
  body { margin: 0 auto !important; }
  body::before {
    content: "${REPORT_PREVIEW_WATERMARK}";
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 2147483647;
    transform: translate(-50%, -50%) rotate(-32deg);
    border: 6px solid rgba(80, 80, 80, 0.13);
    color: rgba(80, 80, 80, 0.14);
    font-family: Arial, Helvetica, sans-serif;
    font-size: 72px;
    font-weight: 800;
    letter-spacing: 8px;
    line-height: 1;
    padding: 24px 36px;
    pointer-events: none;
    text-transform: uppercase;
    white-space: nowrap;
  }
  img, svg, canvas, table { max-width: 100%; }
  @media print {
    html, body {
      width: auto !important;
      min-width: 0 !important;
      max-width: none !important;
      overflow: visible !important;
    }
    body {
      margin: 0 !important;
      background-image: url("${REPORT_PREVIEW_WATERMARK_SVG}");
      background-repeat: repeat;
      background-size: 900px 1200px;
      background-position: center top;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    body::before {
      content: "${REPORT_PREVIEW_WATERMARK}";
      position: fixed;
      top: 50%;
      left: 50%;
      z-index: 2147483647;
      transform: translate(-50%, -50%) rotate(-32deg);
      border: 6px solid rgba(0, 0, 0, 0.14);
      color: rgba(0, 0, 0, 0.16);
      font-family: Arial, Helvetica, sans-serif;
      font-size: 72px;
      font-weight: 800;
      letter-spacing: 8px;
      line-height: 1;
      padding: 24px 36px;
      pointer-events: none;
      text-transform: uppercase;
      white-space: nowrap;
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      display: block !important;
    }
  }
  @media (prefers-color-scheme: dark) {
    html, body {
      background: #ffffff !important;
      color: #000000 !important;
    }
  }
</style>`;

  if (hasViewportMeta) {
    html = html.replace(/<meta[^>]+name=["']viewport["'][^>]*>/i, viewportMeta);
  }

  if (/<head[^>]*>/i.test(html)) {
    return html.replace(/<head[^>]*>/i, (match) => `${match}${lightStyle}`);
  }

  return `${lightStyle}${html}`;
}
